import { Injectable } from '@angular/core';
import { Command } from '../command/command';
import { CommandHandler } from '../command/command-handler';
import { State } from '../state';
import { AppState } from '../state.module';

import {
  AddCurrentWizzardStep,
  AddInitInfoCommand,
  AddPhoneInfoCommand,
  AddRicondizionatoCustomerTypeCommand,
  AddRicondizionatoCustomerIdCommand,
  AddRicondizionatoPaymentIdCommand,
  AddSaleIdCommand,
  AddTotalSaleCommand,
} from "./ricondizionato-commands";

@Injectable()
export class RicondizionatoCommandHandlerService implements CommandHandler {
  handle(state: State, command: Command): State {
    const appState = state as AppState;

    switch (command.name) {
      case "add_current_wizzard_step_ricondizionato":
        const addCurrentWizzardStep = command as AddCurrentWizzardStep;
        return appState.ricondizionato.addCurrentWizzardStep(
          addCurrentWizzardStep.step
        );
      case "add_customer_type_ricondizionato":
        const addRicondizionatoCustomerTypeCommand =
          command as AddRicondizionatoCustomerTypeCommand;
        return appState.ricondizionato.addRicondizionatoCustomerType(
          addRicondizionatoCustomerTypeCommand.type
        );
      case "add_customer_id_ricondizionato":
        const addRicondizionatoCustomerIdCommand =
          command as AddRicondizionatoCustomerIdCommand;
        return appState.ricondizionato.addRicondizionatoCustomerId(
          addRicondizionatoCustomerIdCommand.id
        );
      case "add_phone_info_ricondizionato":
        const addPhoneInfoCommand = command as AddPhoneInfoCommand;
        return appState.ricondizionato.addPhoneInfo(
          addPhoneInfoCommand.saleId,
          addPhoneInfoCommand.totalToPayCent,
          addPhoneInfoCommand.brand,
          addPhoneInfoCommand.model,
          addPhoneInfoCommand.color,
          addPhoneInfoCommand.nmu,
          addPhoneInfoCommand.imei,
          addPhoneInfoCommand.kaskoId,
          addPhoneInfoCommand.customerId,
          addPhoneInfoCommand.shipmentType
        );
    }

    throw new Error(
      `RicondizionatoCommandHandlerService cannot handle command ${command.name}".`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/state/ricondizionato/ricondizionato-command-handler.service.ts